module.exports = __webpack_public_path__ + "static/img/title.e1400ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/title.png
// module id = NRT7
// module chunks = 0